// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__17826","range":"MonthRangeSwitch_range__By2Wi","disabled":"MonthRangeSwitch_disabled__3oMhR"};